<template>
  <hg-dialog :title="title" :width="600" :height="400" :visible.sync="dialogVisible" @close="handleClose">
    <el-form :model="data" size="mini"  :rules="rules" ref="ruleForm" label-width="100px" class="add-box">
      <el-row :gutter="22">
        <el-col :span="22">
          <el-form-item label="编号" prop="code">
            <el-input v-model="data.code" maxlength="50" placeholder="请输入编号" :disabled="isEdit"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="22">
        <el-col :span="22">
          <el-form-item label="资源名称" prop="name">
            <el-input v-model="data.name" maxlength="50" :disabled="!isEdit" placeholder="请输入资源名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="22">
        <el-col :span="22">
          <el-form-item label="资源类型" prop="type">
            <el-select v-model="data.type" placeholder="请选择资源类型" :disabled="!isEdit" style="width: 100%;">
              <el-option label="按钮" value="1" v-if="functionType === 1"></el-option>
              <el-option label="隐藏权限" value="2" v-if="functionType === 1"></el-option>
              <el-option label="组件初始化" value="3" v-if="functionType === 2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="22">
        <el-col :span="22">
          <el-form-item label="操作类型" prop="operateType">
            <el-select v-model="data.operateType" placeholder="请选择操作类型" :disabled="!isEdit" style="width: 100%;">
              <el-option label="登录" value="0" v-if="functionType === 1"></el-option>
              <el-option label="查询" value="1"></el-option>
              <el-option label="新增" value="2" v-if="functionType === 1"></el-option>
              <el-option label="修改" value="3" v-if="functionType === 1"></el-option>
              <el-option label="删除" value="4" v-if="functionType === 1"></el-option>
              <el-option label="打印" value="5" v-if="functionType === 1"></el-option>
              <el-option label="导出" value="6" v-if="functionType === 1"></el-option>
              <el-option label="启用" value="7" v-if="functionType === 1"></el-option>
              <el-option label="停用" value="8" v-if="functionType === 1"></el-option>
              <el-option label="审核" value="9" v-if="functionType === 1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="22">
        <el-col :span="22">
          <el-form-item label="网关" prop="getway">
            <el-input v-model="data.getway" maxlength="50" :disabled="!isEdit" placeholder="请输入网关"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="22">
        <el-col :span="22">
          <el-form-item label="API地址" prop="afterUrl">
            <el-input v-model="data.afterUrl" maxlength="50" :disabled="!isEdit" placeholder="请输入API地址"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="22" v-if="data.type === '3' && functionType === 2">
        <el-col :span="22">
          <el-form-item label="路由地址" prop="routeUrl">
            <el-input v-model="data.routeUrl" maxlength="50" :disabled="!isEdit" placeholder="请输入路由地址"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="22" v-if="data.type === '3'&& functionType === 2">
        <el-col :span="22">
          <el-form-item label="组件名" prop="component">
            <el-input v-model="data.component" maxlength="50" :disabled="!isEdit" placeholder="请输入组件名"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="22">
        <el-col :span="22">
          <el-form-item label="用途" prop="use">
            <el-checkbox-group v-model="data.use" :disabled="!isEdit">
              <el-checkbox label="1" name="use">web</el-checkbox>
              <el-checkbox label="2" name="use">cs</el-checkbox>
              <el-checkbox label="3" name="use">微信</el-checkbox>
              <el-checkbox label="4" name="use">App</el-checkbox>
              <el-checkbox label="5" name="use">云接口</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="hg-dialog-footer">
        <el-button v-if="isEdit" type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button v-else type="primary" @click="edit" size="small" icon="el-hg-icon-edit">修 改</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
    </span>
  </hg-dialog>
</template>
<script>
import HgDialog from '@/components/dialog';

export default {
  name: 'edit',
  components: {
    HgDialog
  },
  props: {
    data: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    },
    functionType: {
      type: Number,
      deFault: 1
    },
    title: {
      String,
      default: '资源详情'
    },
    isEdit: {
      String,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        code: [
          {
            required: true,
            message: '请输入编号',
            trigger: 'blur'
          },
          {
            pattern: this.$utils.regRule.code,
            message: '编号只能含数字和字母',
            trigger: 'blur'
          }
        ],
        name: [{
          required: true,
          message: '请输入资源名称',
          trigger: 'blur'
        }],
        operateType: [{
          required: true,
          message: '请选择操作类型',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择资源类型',
          trigger: 'change'
        }],
        afterUrl: [{
          required: true,
          message: '请输入API地址',
          trigger: 'blur'
        }],
        routeUrl: [{
          required: true,
          message: '请输入路由地址',
          trigger: 'blur'
        }],
        getway: [{
          required: true,
          message: '请输入网关',
          trigger: 'blur'
        }],
        use: [{
          required: true,
          message: '请选择用途',
          trigger: 'change'
        }],
        component: [
          {
            required: true,
            message: '请输入组件名',
            trigger: 'blur'
          },
          {
            pattern: this.$utils.regRule.isComponent,
            message: '组件名只能是字母',
            trigger: 'blur'
          }
        ]
      },
      dataForm: {
        id: '',
        code: '',
        name: '',
        operateType: '1',
        type: '1',
        afterUrl: '',
        routeUrl: '',
        getway: '',
        use: [],
        functionId: '',
        component: '',
        updateFlg: 'update'
      }
    };
  },
  methods: {
    edit() {
      this.$emit('update:isEdit', true);
      this.$emit('update:title', '资源编辑');
    },
    submit() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.dataForm.name = this.data.name;
          this.dataForm.id = this.data.id;
          this.dataForm.code = this.data.code;
          this.dataForm.operateType = this.data.operateType;
          this.dataForm.type = this.data.type;
          this.dataForm.afterUrl = this.data.afterUrl;
          this.dataForm.routeUrl = this.data.routeUrl;
          this.dataForm.getway = this.data.getway;
          this.dataForm.functionId = this.data.functionId;
          this.dataForm.use = this.data.use.join(',');
          this.dataForm.component = this.data.component;
          this.saveResource();
        }
        else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    async saveResource() {
      const res = await this.$services.postJson({
        type: 'RESOURCEMANGEMENT',
        url: 'saveResource',
        params: JSON.parse(JSON.stringify(this.dataForm))
      });
      if (res.code === '000') {
        this.$toaster.ok('保存成功');
        this.handleClose();
        this.$emit('refresh');
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    handleClose() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.$emit('close');
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
      }
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/css/addEditForm.scss';
</style>
